var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selectedNode)?_c('node-input'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }